module.exports = __webpack_public_path__ + "static/media/pinamar.c9b2c607.webp";